import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePolicyHolderInsuree,
  fetchPolicyHolderByInsuree,
  fetchPolicyHolderByInsureeAutoRefresh,
  printInsureeReport,
} from "../action";
import "../styles/theme.scss";
import { useTranslation } from "react-i18next";
import {
  Button,
  Grid,
  Typography,
  Paper,
  IconButton,
  Input,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import TableN from "../reusableComponents/components/generics/TableN";
import CommonSnackbar from "../reusableComponents/components/generics/CommonSnackbar";
import AddInsureeDialog from "./dialog/AddInsureeDialog";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import UpdateInsureesDialog from "./dialog/UpdateInsureesDialog";
import DialogBox from "../reusableComponents/components/dialogs/DialogBox";
import { styled } from "@mui/system";
import { decodeId } from "../utils/helper";
import { clearPrintInsureeSuccess } from "../store/actions/exampleAction";
const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));
function InsureeTable({
  policyHolderId,
  filter,
  setInsureeData,
  insureeCheck,
}) {
  const SignInSuccess = useSelector((state) => state);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [printData, setPrintData] = useState();
  const [policyHolderData, setPolicyHolderData] = useState();
  const [rowDataForEdit, setRowDataForEdit] = useState(null);
  const [currentUser, setCurrentUSer] = useState();
  const [showDialog, setShowDialog] = useState(false);
  const [showUpdateDialog, setShowUpdateDialog] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [insureeToDelete, setInsureeToDelete] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageInfo, setPageInfo] = useState();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [endCursors, setEndCursors] = useState(null);
  const [startCursors, setStartCursors] = useState(null);
  // useEffect(() => {
  //     dispatch(loadingUser(token))
  // }, [])
  const mutation = SignInSuccess?.profileReducer?.mutations;
  useEffect(() => {
    // const mutation = SignInSuccess?.profileReducer?.mutations;
    if (snackbarMessage) {
      if (mutation && mutation.length > 0 && mutation[0]?.status === 2) {
        setSnackbarSeverity("success");
        // setSnackbarMessage('Isuree Successfully add in to policyholder.');
        setSnackbarOpen(true);
        setShowUpdateDialog(false);
        setShowDialog(false);
        setDeleteDialogOpen(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (mutation && mutation.length > 0 && mutation[0]?.status === 1) {
        setSnackbarSeverity("error");
        setSnackbarMessage(t("Failed to done any action in policyholder."));
        setSnackbarOpen(true);
        setShowUpdateDialog(false);
        setShowDialog(false);
        setDeleteDialogOpen(false);
      } else if (!mutation) {
        setSnackbarOpen(false);
      }
    }
  }, [mutation?.[0]?.id]);

  useEffect(() => {
    console.log(pageSize, 'pageSize');
    let params = buildQueryParams({
      filters: filter,
      pageSize,
      beforeCursor: endCursors,
      afterCursor: startCursors,
      orderBy: "insuree",
      policyHolderId: policyHolderId?.id,
    });
    if (policyHolderId?.id) {
      dispatch(fetchPolicyHolderByInsuree(params));
    }
  }, [policyHolderId, filter, insureeCheck, mutation, page, pageSize]);

  useEffect(() => {
    if (SignInSuccess?.profileReducer?.policyHolderByInsureeResponseData) {
      setPolicyHolderData(
        SignInSuccess?.profileReducer?.policyHolderByInsureeResponseData
      );
      setInsureeData(
        SignInSuccess?.profileReducer?.policyHolderByInsureeResponseData
      );
      setPageInfo(
        SignInSuccess?.profileReducer?.policyHolderByInsureeResponseDataPageInfo
          .totalCount
      );
      setStartCursors(
        SignInSuccess?.profileReducer?.policyHolderByInsureeResponseDataPageInfo
          ?.endCursor
      );
      setEndCursors(
        SignInSuccess?.profileReducer?.policyHolderByInsureeResponseDataPageInfo
          ?.startCursor
      );
    }
  }, [SignInSuccess]);

  useEffect(() => {
    if (SignInSuccess?.profileReducer?.printInsuree) {
      setPrintData(SignInSuccess?.profileReducer?.printInsuree);
    }
  }, [printData, SignInSuccess]);
  useEffect(() => {
    if (printData) {
      let contentType = "pdf";
      displayPrintWindow(printData, contentType);
    }
    return () => {
      dispatch(clearPrintInsureeSuccess());
    };
  }, [printData]);

  const openAddInsureeDailog = () => {
    setShowDialog(!showDialog);
  };
  const handleEdit = (rowData) => {
    setShowUpdateDialog(true);
    setRowDataForEdit(rowData);
  };
  const handleDeleteClick = (rowData) => {
    setInsureeToDelete(rowData);
    setDeleteDialogOpen(true);
  };
  const handleDeleteAgree = async () => {
    dispatch(deletePolicyHolderInsuree(insureeToDelete?.id));
    setDeleteDialogOpen(false);
    setSnackbarMessage(t("Insuree Deleted SucessFully"));
  };
  const handleSnackbarClose = async (event, reason) => {
    // window.location.reload();
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  const displayPrintWindow = (base64Data, contentType) => {
    const printWindow = window.open(
      "",
      "Print Window",
      "width=600, height=400"
    );
    printWindow.document.open();

    if (contentType === "pdf") {
      // printWindow.print(`<embed type="application/pdf" width="100%" height="100%" src="data:application/pdf;base64,${base64Data}" />`);
      printWindow.document.write(
        `<embed type="application/pdf" width="100%" height="100%" src="data:application/pdf;base64,${base64Data}" />`
      );
    } else {
      printWindow.document.write(
        `<img src="data:image/png;base64,${base64Data}" />`
      );
    }
    printWindow.document.close();
  };
  const printReport = async (edited) => {
    await dispatch(printInsureeReport(edited));
  };
  const headers = () => {
    var h = [
      t("Insuree Name"),
      t("ContributionPlanBundle"),
      t("Income"),
      t("Employer Number"),
      t("Created From"),
      t("Valid From"),
      t("Action"),
    ];

    return h;
  };
  const itemFormatters = () => {
    var row = [
      (policyHolderInsuree) =>
        !!policyHolderInsuree.insuree
          ? `${policyHolderInsuree.insuree.lastName}-${policyHolderInsuree.insuree.otherNames}`
          : "",
      (policyHolderInsuree) =>
        !!policyHolderInsuree.contributionPlanBundle
          ? `${policyHolderInsuree.contributionPlanBundle?.code} - ${policyHolderInsuree.contributionPlanBundle?.name}`
          : "",
      (policyHolderInsuree) => {
        const { lastPolicy, ...others } = policyHolderInsuree;
        const policy = !!lastPolicy ? lastPolicy : {};
        const jsonData = JSON.parse(policyHolderInsuree.jsonExt);
        const income = jsonData?.calculation_rule?.income;
        return !!policyHolderInsuree.jsonExt ? income : "";
      },
      (policyHolderInsuree) =>
        policyHolderInsuree?.employerNumber
          ? policyHolderInsuree?.employerNumber
          : "",
      (policyHolderData) => {
        const dateValidFrom = new Date(policyHolderData.dateValidFrom);
        return dateValidFrom.toLocaleDateString("en-GB"); // Change 'en-GB' to your preferred locale if needed
      },
      (policyHolderData) => {
        const dateValidTo = new Date(policyHolderData.dateValidTo);
        return dateValidTo.toLocaleDateString("en-GB"); // Change 'en-GB' to your preferred locale if needed
      },
      (policyHolderData, idx) => (
        <div style={{ display: "flex" }}>
          <IconButton onClick={() => printReport(policyHolderData)}>
            <PrintIcon />
          </IconButton>
          <IconButton onClick={() => handleEdit(policyHolderData)}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => handleDeleteClick(policyHolderData)}>
            <DeleteForeverIcon />
          </IconButton>
        </div>
      ),
    ];

    return row;
  };
  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to the first page when changing page size
    setEndCursors(null);
    setStartCursors(null);
  };

  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    params.push(`isDeleted: false`);
    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }
    if (!!state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    if (!!state.policyHolderId) {
      params.push(`policyHolder_Id: "${decodeId(state.policyHolderId)}"`);
    }
    return params;
  };
  const handleNavigation = (direction) => {
    if (direction === "forward") {
      setEndCursors(null);
    } else if (direction === "backward") {
      setStartCursors(null);
    }
  };
  return (
    <Grid container>
      {/* <TableN/> */}
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader container alignItems="center" direction="row">
            <Grid item alignItems="center">
              <Typography variant="h6">
                {t("Insuree")}-{pageInfo}
              </Typography>
            </Grid>
            {policyHolderData && (
              <Button
                onClick={openAddInsureeDailog}
                color="primary"
                variant="contained"
                startIcon={<AddIcon />}
                style={{ marginLeft: "auto" }}
              >
                {t("Add New Insuree")}
              </Button>
            )}
          </StyledPaperHeader>
          <TableN
            module="insuree"
            headers={headers()}
            // headerActions={headerActions}
            itemFormatters={itemFormatters()}
            items={policyHolderData ? policyHolderData : []}
            // error={!!errorFullfamilyPendingApproval ? errorFullfamilyPendingApproval : null}
            withSelection={"single"}
            withPagination={true}
            rowsPerPageOptions={[10, 50, 100]}
            defaultPageSize={5}
            page={page}
            pageSize={pageSize}
            count={pageInfo}
            // onChangePage={(event, newPage) => setPage(newPage)}
            onChangePage={(event, newPage) => {
              setPage(newPage);
              handleNavigation(newPage > page ? "forward" : "backward");
            }}
            onChangeRowsPerPage={handleRowsPerPageChange}
          // rowLocked={this.rowLocked}
          />
          {!policyHolderData && (
            <Grid>
              {/* <Typography style={{ color: "red", fontWeight: "bold", fontSize: "16px", marginTop: "10px", marginLeft: "28rem" }}>{t("There is no Insuree Available")}</Typography> */}
              <Button
                onClick={openAddInsureeDailog}
                color="primary"
                variant="outlined"
                startIcon={<AddIcon />}
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  marginLeft: "25rem",
                }}
              >
                {t("Add New Insuree")}
              </Button>
            </Grid>
          )}
        </StyledPaper>
      </Grid>

      {showDialog && (
        <AddInsureeDialog
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          currentUser={currentUser}
          rowData={rowDataForEdit}
          setSnackbarMessage={setSnackbarMessage}
        />
      )}
      {showUpdateDialog && (
        <UpdateInsureesDialog
          showUpdateDialog={showUpdateDialog}
          setShowUpdateDialog={setShowUpdateDialog}
          currentUser={policyHolderId}
          rowData={rowDataForEdit}
          setSnackbarMessage={setSnackbarMessage}
        />
      )}
      {deleteDialogOpen && (
        <DialogBox
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
          onAgree={handleDeleteAgree}
          title="Confirmation"
          content={`${t("Are you sure you want to delete? Insuree")}- ${insureeToDelete?.insuree?.otherNames}`}
          agreeLabel="Delete"
          disagreeLabel="Cancel"
        />
      )}
      <CommonSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Grid>
  );
}

export default InsureeTable;
